import { IAtlasObjectRef } from '@common/helpers/atlasUrls'
import { IGetAtlasObjectDetailParams } from '@common/interfaces/atlasObjects'
import { IApi } from '../../api'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'atlasPreview'

export const OPEN_ATLAS_PREVIEW = `${prefix}/OPEN_ATLAS_PREVIEW`
export const CLOSE_ATLAS_PREVIEW = `${prefix}/CLOSE_ATLAS_PREVIEW`

export const [GET_OBJECT_DETAIL_REQUEST, GET_OBJECT_DETAIL_SUCCESS, GET_OBJECT_DETAIL_FAILURE] =
  createRequestTypes(prefix, 'GET_OBJECT_DETAIL')

export interface IAtlasPreviewTarget {
  ref: IAtlasObjectRef
  url: string
}

export const openAtlasPreview = (target: IAtlasPreviewTarget) => ({
  type: OPEN_ATLAS_PREVIEW,
  data: target,
})

export const closeAtlasPreview = () => ({
  type: CLOSE_ATLAS_PREVIEW,
})

export const getAtlasObjectDetail = createAction((params: IGetAtlasObjectDetailParams) => ({
  type: [GET_OBJECT_DETAIL_REQUEST, GET_OBJECT_DETAIL_SUCCESS, GET_OBJECT_DETAIL_FAILURE],
  promise: (api: IApi) => api.atlasLinks.getObjectDetail(params),
  params,
}))
